








































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {RotaSla} from '@/model/resource/RotaSla'
import {RotaSlaCollection} from '@/model/collection/RotaSlaCollection'
import {ListRotaSlaSchema} from '@/schema/resource/RotaSla/ListRotaSlaSchema'
import {CsvRotaSlaSchema} from '@/schema/resource/RotaSla/CsvRotaSlaSchema'

@Component
export default class ListRotaSlaView extends Mixins(MixinQueryRouter) {
  schema = new ListRotaSlaSchema()
  collection = new RotaSlaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: RotaSla) {
    Helper.pushByName(
      'editRotaSla',
      item.idResponsavelFk,
      item.idOrigemFk as number,
      item.idDestinoFk as number
    )
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new RotaSlaCollection().clearFilters().addFilter(params)

    await csv.listCsvRotaSla()
    new CsvRotaSlaSchema().downloadCsv(csv.all())
  }
}
